
import GooglePlay from "../../../assets/filled/GooglePlay.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GooglePlayIcon({ className, dataTestid = "GooglePlayIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GooglePlay data-testid={dataTestid} className={classes} {...rest} />
  );
}
